{
	"computer": "ordenador",
	"notInformed": "Sin nombre",
	"productImage": "Foto del producto",
	"searchMoreOptions": "Buscar más opciones de base de datos",
	"select": "Selecciona una foto",
	"selectFrom": "Seleccionar desde ",
	"setTagInput": "Buscar el producto usando palabras clave"
}
